import { Calendar } from 'antd';

export const AntCalendar = Calendar;
